
GH.ready(function () {
  /* Press feedback and the badge icons live in the shared library: every design shows
     the same controls and the same three badges, and both have to dodge the same reset.
     The prefix tells them which one — see GH.ripple in the data block. */
  function ripple(host, ev) { GH.ripple(host, ev, 'p1'); }
  function pop(el)          { GH.pop(el, 'p1'); }

  /* A colour taken dark enough to carry white type - or to be read AS type on white,
     which is the same threshold either way.

     Scaling all three channels by a constant is the obvious way to darken and it is the
     wrong one: it drags every colour toward grey, so Ethiopia's orange arrived as a
     muddy brown indistinguishable from Espresso, and Guatemala's mint as a grey-green.
     Dropping LIGHTNESS while pushing SATURATION up instead keeps the hue alive - the
     same orange lands at rgb(175,93,0), a real burnt orange, at the same 4.8:1. */
  function deepen(hex) {
    var m = /^#?([0-9a-f]{6})$/i.exec(String(hex || ''));
    if (!m) return 'rgb(31,27,22)';
    var v = parseInt(m[1], 16);
    var r = (v >> 16) / 255, g = ((v >> 8) & 255) / 255, b = (v & 255) / 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b);
    var h = 0, sat = 0, l = (mx + mn) / 2;
    if (mx !== mn) {
      var dd = mx - mn;
      sat = l > 0.5 ? dd / (2 - mx - mn) : dd / (mx + mn);
      h = mx === r ? (g - b) / dd + (g < b ? 6 : 0)
        : mx === g ? (b - r) / dd + 2
        : (r - g) / dd + 4;
      h /= 6;
    }
    function toRgb(hh, ss, ll) {
      function hue(p2, q2, t) {
        if (t < 0) t += 1; if (t > 1) t -= 1;
        if (t < 1 / 6) return p2 + (q2 - p2) * 6 * t;
        if (t < 1 / 2) return q2;
        if (t < 2 / 3) return p2 + (q2 - p2) * (2 / 3 - t) * 6;
        return p2;
      }
      if (ss === 0) return [ll * 255, ll * 255, ll * 255].map(Math.round);
      var q = ll < 0.5 ? ll * (1 + ss) : ll + ss - ll * ss, p2 = 2 * ll - q;
      return [hue(p2, q, hh + 1 / 3), hue(p2, q, hh), hue(p2, q, hh - 1 / 3)]
        .map(function (x) { return Math.round(x * 255); });
    }
    function lum(x) {
      var a = x.map(function (n) {
        n /= 255; return n <= 0.03928 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4);
      });
      return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
    }
    var out = toRgb(h, sat, l);
    for (var i = 0; i < 60 && (1.05 / (lum(out) + 0.05)) < 4.5; i++) {
      l *= 0.94; sat = Math.min(1, sat * 1.05);
      out = toRgb(h, sat, l);
    }
    return 'rgb(' + out.join(',') + ')';
  }
  /* the old name, kept because the ramps and the note line both call it */
  var onWhite = deepen;


  /* The same rule the Add button follows, for any one-off colour that has to carry type:
     dark ink first because that is what keeps a colour vivid, white second, and only move
     the colour when neither reads - then move it whichever way is shorter. Used by the
     Trio's three coloured caps, so Honduras stays blue and Ethiopia stays orange. */
  function tone(hex) {
    var m = /^#?([0-9a-f]{6})$/i.exec(String(hex || ''));
    if (!m) return { bg: '#1F1B16', tx: '#fff' };
    var v = parseInt(m[1], 16), c = [v >> 16, (v >> 8) & 255, v & 255];
    var INK = [31, 27, 22], WHITE = [255, 255, 255];
    function lum(x) {
      var a = x.map(function (n) {
        n /= 255; return n <= 0.03928 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4);
      });
      return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
    }
    function cr(a, b) {
      var x = lum(a), y = lum(b);
      return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05);
    }
    var rgb = function (x) { return 'rgb(' + x.join(',') + ')'; };
    if (cr(c, INK) >= 4.5)   return { bg: rgb(c), tx: '#1F1B16' };
    if (cr(c, WHITE) >= 4.5) return { bg: rgb(c), tx: '#fff' };
    function walk(toward, type) {
      var x = c.slice(), k = 0;
      while (k < 40 && cr(x, type) < 4.5) {
        x = x.map(function (n, i) { return Math.round(n + (toward[i] - n) * 0.06); });
        k++;
      }
      return { c: x, k: k, ok: cr(x, type) >= 4.5 };
    }
    var dk = walk([0, 0, 0], WHITE), lt = walk(WHITE, INK);
    if (lt.ok && (!dk.ok || lt.k < dk.k)) return { bg: rgb(lt.c), tx: '#1F1B16' };
    return { bg: rgb(dk.ok ? dk.c : c), tx: '#fff' };
  }

  var roots = document.querySelectorAll('.p1');
  for (var i = 0; i < roots.length; i++) build(roots[i]);

  function build(root) {
    if (!root || root.dataset.p1Ready) return;
    root.dataset.p1Ready = '1';

    var P = GH.pick();
    /* This product is not in the data file, so this design has nothing to draw. Stand
       aside and show the plain Liquid page the section carries for exactly this case,
       rather than leaving a blank screen or, worse, drawing a different product. */
    if (!P) {
      root.hidden = true;
      /* belt and braces: the stylesheet may not have loaded, and .p1 carries
         display:block !important for theme-proofing */
      root.style.setProperty('display', 'none', 'important');
      var fb = document.querySelector('.gh-fallback');
      if (fb) { fb.hidden = false; fb.style.display = 'block'; }
      return;
    }
    var S = GH.shared;
    var esc = GH.esc, money = GH.money;

    root.style.setProperty('--p1-tone', P.color || '#1F1B16');
    /* the two products with an actual finish rather than a flat colour */
    root.classList.toggle('is-metal', P.sheen === 'gold');
    root.classList.toggle('is-irid',  P.sheen === 'iridescent');

    /* The flavour band puts white type on the bag colour, and the notes line puts the bag
       colour on white — both need the same thing: a version of that colour dark enough to
       read against white. Honduras blue and Guatemala teal are mid-toned enough to fail at
       4.33:1 as they are, so the colour is walked toward black a few percent at a time
       until it clears. The hue is kept, so it still reads as that coffee's colour, and the
       untouched --p1-tone still marks the dot and the thumbnails. */
    (function () {
      var m = /^#?([0-9a-f]{6})$/i.exec(String(P.color || ''));
      if (!m) return;
      var v = parseInt(m[1], 16), c = [v >> 16, (v >> 8) & 255, v & 255];
      function lum(x) {
        var a = x.map(function (n) {
          n /= 255; return n <= 0.03928 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4);
        });
        return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
      }
      var raw = c.slice();
      for (var i = 0; i < 24 && (1.05 / (lum(c) + 0.05)) < 4.5; i++) {
        c = c.map(function (n) { return Math.round(n * 0.95); });
      }
      var rgb = function (x) { return 'rgb(' + x.join(',') + ')'; };
      root.style.setProperty('--p1-toneT', rgb(c));

      /* The controls take the bag's colour so a Honduras page reads as Honduras rather
         than as a template with the name swapped.

         The button used to be toneT — the darkened version — with white type forced on
         it. That works for a blue, but it ruined the oranges: Ethiopia's #E08A2B only
         scores 2.68 against white, so it was walked down until it cleared, and came out
         a brown all but identical to Espresso's. Two different coffees, one colour.

         So the TYPE bends to the bag rather than the bag bending to the type. Dark ink
         first, because that is what lets a bright colour stay bright; white second; and
         only when neither clears 4.5 does the colour get darkened at all. Ethiopia keeps
         its orange at 6.4:1 on ink, Honduras still darkens to the blue that reads. */
      var INK = [31, 27, 22];
      function contrast(a, b) {
        var x = lum(a), y = lum(b);
        return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05);
      }
      var WHITE = [255, 255, 255];
      /* nudge the colour toward a target until the given type reads on it, and report
         how far it had to travel — the fewer steps, the truer to the bag it stayed */
      function walk(start, toward, type) {
        var x = start.slice(), k = 0;
        while (k < 40 && contrast(x, type) < 4.5) {
          x = x.map(function (n, i) { return Math.round(n + (toward[i] - n) * 0.06); });
          k++;
        }
        return { c: x, steps: k, ok: contrast(x, type) >= 4.5 };
      }

      var btn, txt;
      if (contrast(raw, INK) >= 4.5)          { btn = raw; txt = 'rgb(31,27,22)'; }
      else if (contrast(raw, WHITE) >= 4.5)   { btn = raw; txt = '#fff'; }
      else {
        /* Neither reads on the bag colour as it is, so it has to move — but it can move
           in either direction, and the right one is whichever moves LEAST. Guatemala's
           teal misses dark ink by a hair (4.41) and misses white by a mile (3.88), so
           lifting it a couple of percent keeps a vivid teal, where darkening it for
           white type dragged it to a muddy green. Honduras is the opposite and still
           darkens to the blue it should be. */
        var dark  = walk(raw, [0, 0, 0], WHITE);
        var light = walk(raw, WHITE, INK);
        if (light.ok && (!dark.ok || light.steps < dark.steps)) {
          btn = light.c; txt = 'rgb(31,27,22)';
        } else {
          btn = dark.ok ? dark.c : c; txt = '#fff';
        }
      }
      root.style.setProperty('--p1-cta', rgb(btn));
      root.style.setProperty('--p1-ctatx', txt);
      /* hover darkens a touch; 0.88 keeps ink readable on the light-buttoned products */
      root.style.setProperty('--p1-ctah',
        rgb(btn.map(function (n) { return Math.round(n * 0.88); })));
      /* a wash of the same colour for the chosen button, light enough to keep ink on it */
      root.style.setProperty('--p1-tint',
        rgb(c.map(function (n) { return Math.round(n + (255 - n) * 0.9); })));
      root.style.setProperty('--p1-tintb',
        rgb(c.map(function (n) { return Math.round(n + (255 - n) * 0.72); })));
      /* the ground for "while you're here": the bag colour washed to 84% white. Light,
         but unmistakably this coffee's colour rather than the near-white cream the
         product cards sit on. Taken from the raw colour, not the darkened one, so the
         hue stays true — Ethiopia washes orange, not brown. */
      /* Washing 84% toward white suits a mid-toned bag, but Half-Caffeine's label is a
         light peach to begin with — pushed that far it would come out indistinguishable
         from paper and the panel would look untinted. So a pale bag is washed less. */
      var mix = lum(raw) > 0.5 ? 0.5 : 0.84;
      var panel = raw.map(function (n) { return Math.round(n + (255 - n) * mix); });
      root.style.setProperty('--p1-panel', rgb(panel));
      /* the kicker sitting ON that panel. toneT is only proven against pure white, and
         the panel is a shade darker than that, which dropped it to 3.8 — so it is taken
         down until it clears against the panel it actually sits on. */
      var onp = c.slice();
      for (var q = 0; q < 24 && contrast(onp, panel) < 4.5; q++) {
        onp = onp.map(function (n) { return Math.round(n * 0.92); });
      }
      root.style.setProperty('--p1-onpanel', rgb(onp));

      /* Every soft surface on the page — the photo backdrop, the thumbnails, the meter,
         the badges, the review cards, the "while you're here" band — was one shared
         cream. They now take a wash of the bag colour instead, so a Honduras page reads
         blue throughout and a Colombia page purple. 93% white keeps it a tint rather
         than a colour, so the body and muted greys on top of it still pass contrast. */
      root.style.setProperty('--p1-soft',
        rgb(c.map(function (n) { return Math.round(n + (255 - n) * 0.93); })));
      /* the hairline that borders those surfaces, a shade further in */
      root.style.setProperty('--p1-line',
        rgb(c.map(function (n) { return Math.round(n + (255 - n) * 0.78); })));
    })();

    /* ---------- the photographs: all of them, however many there are ---------- */
    var shots = P.images || [];
    var shown = 0;
    root.querySelector('.p1-media').innerHTML =
      /* no flavour band across the photo here — the notes already sit under the name,
         and saying it twice on one screen is just noise */
      '<div class="p1-shot">' +
        '<img class="p1-main" src="' + esc(GH.img(shots[0].src, 900)) + '" alt="' +
          esc(shots[0].alt || P.title) + '" loading="eager" decoding="async">' +
        (P.best ? '<span class="p1-flag">Best seller</span>' : '') +
      '</div>' +
      (shots.length > 1
        ? '<div class="p1-thumbs">' + shots.map(function (m, i) {
            return '<button type="button" class="p1-thumb" aria-pressed="' + (i === 0) +
              '" aria-label="Photo ' + (i + 1) + ' of ' + shots.length + '">' +
              '<img src="' + esc(GH.img(m.src, 200)) + '" alt="" loading="lazy" decoding="async">' +
              '</button>';
          }).join('') + '</div>'
        : '');

    var mainImg = root.querySelector('.p1-main');
    var thumbs  = root.querySelector('.p1-thumbs');
    if (thumbs) {
      thumbs.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('.p1-thumb') : null;
        if (!b) return;
        var list = [].slice.call(thumbs.querySelectorAll('.p1-thumb'));
        shown = list.indexOf(b);
        list.forEach(function (x, i) { x.setAttribute('aria-pressed', String(i === shown)); });
        mainImg.src = GH.img(shots[shown].src, 900);
        mainImg.alt = shots[shown].alt || P.title;
      });
    }

    /* ---------- the buy box, in the order the live page uses ---------- */
    var opts   = GH.choosable(P);       /* whatever this product's real options are */
    var plans  = GH.plans(P);
    /* The Trio's three coffees, resolved from the live product records rather than from
       the copy stored alongside it — a stored colour goes stale the moment a bag colour
       is corrected, which is exactly what happened to Ethiopia. Title, notes and photo
       come from the same place, so the box can never describe a coffee that changed. */
    var mem = (P.members || []).map(function (m) {
      var live = (GH_COFFEE || []).filter(function (x) { return x.handle === m.handle; })[0];
      if (!live) return m;
      return {
        handle: m.handle, title: live.title, color: live.color || m.color,
        notes: live.notes || m.notes, roast: live.roast || m.roast,
        /* authored alongside the member, not on the live product — carry it through or
           it is silently dropped by this rebuild */
        facts: m.facts || [],
        img: (live.images && live.images[0] && live.images[0].src) || m.img,
        /* what one 12oz bag of it costs on its own — the number the bundle argues against */
        solo: (function () {
          var v = (live.variants || []).filter(function (x) {
            return x.opts && x.opts.Size === '12oz'; })[0];
          return v ? v.price : null;
        })()
      };
    });

    /* The Trio wears all three coffees rather than one flat brown. Two ramps are set up
       here: a deep one for anything carrying white type, and a pale one for backgrounds.
       The deep stops come from onWhite(), which walks each colour until it clears 4.5:1
       against white — and contrast is symmetric, so that is exactly the condition for
       white type to be readable ON it. Every point of the gradient is therefore safe,
       not just the ends. A raw ramp would have put white on Ethiopia's light orange. */
    root.classList.toggle('is-trio', mem.length >= 3);
    if (mem.length >= 3) {
      /* Blue, then brown, then orange — the order runs coolest to warmest so the ramp
         ends on Ethiopia's amber rather than dying in the middle of two browns. The
         card order below is unchanged; this is only the order the colours ramp in. */
      var order = ['honduras', 'espresso-blend-copy', 'ethiopia-yirgacheffe'];
      var ramp = order.map(function (h) {
        return mem.filter(function (m) { return m.handle === h; })[0];
      }).filter(Boolean);
      if (ramp.length < 3) ramp = mem.slice(0, 3);

      ramp.forEach(function (m, i) {
        var v = /^#?([0-9a-f]{6})$/i.exec(String(m.color || ''));
        if (!v) return;
        var n = parseInt(v[1], 16), c = [n >> 16, (n >> 8) & 255, n & 255];
        /* deep: for surfaces that carry white type. Every stop clears 4.5 against white,
           which is the same condition as white being readable on it. */
        root.style.setProperty('--p1-g' + (i + 1), onWhite(m.color));
        /* bright: the colours AS THEY ARE. These go on things with no type on them —
           outlines, rules, the meter, the icons — which is the only way Ethiopia's
           orange can appear at full strength anywhere on this page. */
        root.style.setProperty('--p1-b' + (i + 1), 'rgb(' + c.join(',') + ')');
        /* pale: for backgrounds under dark ink */
        root.style.setProperty('--p1-l' + (i + 1),
          'rgb(' + c.map(function (x) { return Math.round(x + (255 - x) * 0.86); }).join(',') + ')');
      });
    }

    var chosen = GH.firstChoice(P);
    var qty = 1;
    var sub = null;                 /* null = one-time; otherwise the chosen plan */
    /* off until the first sync has run, so the page does not open with every preselected
       button popping at once */
    var popsOn = false;
    /* extra bits of the page that have to follow the buy box's choices. Each is handed
       the current variant on every sync, so nothing can drift out of step with it. */
    var syncers = [];
    var inCart = 0;
    /* true only between a successful add and the next change the customer makes */
    var justAdded = false;

    var hasRating = P.rating != null && P.ratingCount != null;

    /* a control per option, labelled with the option's own name. A price is only shown
       under the values when the price actually changes with that option — sizes do,
       grind and colour do not, and repeating $19 six times says nothing. */
    function control(o) {
      var priced = o.values.map(function (v) { return GH.priceForValue(P, o.name, v, chosen); });
      var varies = priced.filter(function (x) { return x != null; })
                         .some(function (x, _, a) { return x !== a[0]; });
      var wide = o.values.length === 2 ? ' p1-opts--two' : '';
      return '<div class="p1-choose"><p class="p1-legend">' + esc(o.name) + '</p>' +
        '<div class="p1-opts' + wide + '">' +
          o.values.map(function (v, i) {
            /* a value with nothing in stock says so, rather than just going grey */
            var gone = !(P.variants || []).some(function (x) {
              return x.available && x.opts[o.name] === v; });
            var sub = gone ? 'Sold out' : (varies && priced[i] != null ? money(priced[i]) : '');
            return '<button type="button" class="p1-opt" data-opt="' + esc(o.name) +
              '" data-val="' + esc(v) + '" aria-pressed="' + (v === chosen[o.name]) + '">' +
              '<b>' + esc(v) + '</b>' + (sub ? '<i>' + esc(sub) + '</i>' : '') +
              '</button>';
          }).join('') +
        '</div></div>';
    }

    root.querySelector('.p1-buy').innerHTML =
      /* the roast line belongs to coffee; a mug has no roast, so it gets no eyebrow */
      (P.roast
        ? '<p class="p1-eyebrow"><i></i>' + esc(P.roast) + ' roast &middot; Roasted in Belmond</p>'
        : '') +
      '<h1 class="p1-name" id="p1-name">' + esc(P.title) + '</h1>' +
      /* the Trio is three coffees, so it wears all three colours rather than picking one */
      (mem.length
        ? '<span class="p1-tribar">' + mem.map(function (m) {
            return '<i style="background:' + tone(m.color).bg + '"></i>';
          }).join('') + '</span>'
        : '') +
      (P.notes && P.notes.length
        /* On the Trio each note pair IS one of the three coffees, so it wears that
           coffee's colour. As plain text on white it could not: text needs 4.5:1, and an
           orange dark enough to clear that is brown — which is exactly how Ethiopia kept
           coming out. On a chip the colour is the BACKGROUND, so it can stay the real
           #FAA84A with dark ink on top, and Ethiopia finally looks orange. */
        ? (mem.length >= 3
            /* All three chips carry white, so the set reads as one thing rather than two
               white and one black. That means each colour has to be deep enough to hold
               white — done by deepen(), which drops lightness while raising saturation,
               so Ethiopia lands on a burnt orange instead of the brown that uniform
               darkening produced. */
            ? '<p class="p1-notes p1-notes--tri">' + P.notes.map(function (n, i) {
                return mem[i]
                  ? '<span class="p1-nchip" style="background:' + deepen(mem[i].color) + '">' +
                    esc(n) + '</span>'
                  : '<span class="p1-nchip">' + esc(n) + '</span>';
              }).join('') + '</p>'
            : '<p class="p1-notes">' + P.notes.map(esc).join(' &middot; ') + '</p>')
        : '') +
      (hasRating
        ? '<p class="p1-rating"><span class="p1-stars" aria-hidden="true">★★★★★</span>' +
          '<span>' + esc(P.rating) + ' from ' + esc(P.ratingCount) +
          (String(P.ratingCount) === '1' ? ' review' : ' reviews') + '</span></p>'
        : '') +
      (P.description ? GH.paras(P.description, 'p1-blurb') : '') +

      opts.map(control).join('') +

      /* Whatever is typed here rides along with the line item, exactly as it does on the
         live page today — but only on the coffee. A grind request is the whole reason
         this box exists, and there is nothing to ask for about a mug, a bag of granola
         or a tub of chocolates. An empty invitation to make a request is worse than no
         invitation at all. */
      (S.specialRequests && P.kind === 'coffee'
        ? '<div class="p1-req"><p class="p1-legend">' + esc(S.specialRequests.label) + '</p>' +
            '<p class="p1-reqhelp">' + esc(S.specialRequests.help) + '</p>' +
            /* The placeholder is the only thing that teaches anyone this box is worth
               using, so it carries the free cold brew bags — which come with any order,
               merch included, and which nobody would think to ask for otherwise. */
            '<textarea class="p1-reqbox" rows="2" maxlength="' +
              (S.specialRequests.max || 150) + '" placeholder="' +
              esc(S.specialRequests.placeholder || '') + '"></textarea>' +
            '<p class="p1-reqcount"><span>0</span>/' + (S.specialRequests.max || 150) + '</p>' +
          '</div>'
        : '') +

      /* the subscription group covers the ten coffees; The Trio is not in it */
      (plans.length
        ? '<div class="p1-choose"><p class="p1-legend">Purchase</p>' +
            '<div class="p1-plan is-on" data-kind="once">' +
              '<button type="button" class="p1-planhead"><span class="p1-tick"></span>' +
                '<span class="p1-planwho"><span class="p1-plantitle">' +
                  esc(S.subscription.oneTime) + '</span></span>' +
                '<span class="p1-plancost p1-oncecost"></span>' +
              '</button>' +
            '</div>' +
            '<div class="p1-plan" data-kind="sub">' +
              '<button type="button" class="p1-planhead"><span class="p1-tick"></span>' +
                '<span class="p1-planwho"><span class="p1-plantitle">' +
                  esc(S.subscription.groupName) + '</span>' +
                  '<span class="p1-plansub">Save up to ' +
                    Math.max.apply(null, plans.map(function (x) { return x.off; })) +
                    '%</span></span>' +
                '<span class="p1-plancost p1-subcost"></span>' +
              '</button>' +
              '<div class="p1-plans">' +
                plans.map(function (pl, i) {
                  return '<button type="button" class="p1-freq" data-plan="' + pl.id +
                    '" aria-pressed="' + (i === 0) + '">' + esc(pl.label) +
                    '<b data-planprice="' + pl.id + '"></b></button>';
                }).join('') +
                '<p class="p1-foot">' + esc(S.subscription.footnote) + '</p>' +
              '</div>' +
            '</div>' +
          '</div>'
        : '') +

      '<div class="p1-qtyrow">' +
        '<span class="p1-qty">' +
          '<button type="button" class="p1-step" data-step="-1" aria-label="One fewer">&minus;</button>' +
          '<span class="p1-num" aria-live="polite">1</span>' +
          '<button type="button" class="p1-step" data-step="1" aria-label="One more">+</button>' +
        '</span>' +
        '<span class="p1-total"><span class="p1-price"></span>' +
          '<span class="p1-per"></span></span>' +
      '</div>' +

      '<div class="p1-meter"><p class="p1-mtxt"></p>' +
        '<span class="p1-track"><span class="p1-fill"></span></span>' +
        '<button type="button" class="p1-more"></button>' +
      '</div>' +

      '<button type="button" class="p1-add">Add to cart</button>' +
      '<ul class="p1-badges">' +
        (S.badges || []).map(function (b) {
          var bit = GH.badge(b);
          return '<li class="p1-badge"><span class="p1-bico">' + bit.svg +
                 '</span><span class="p1-btx">' + esc(bit.t) + '</span></li>';
        }).join('') +
      '</ul>';

    var priceEl = root.querySelector('.p1-price');
    var perEl   = root.querySelector('.p1-per');
    var numEl   = root.querySelector('.p1-num');
    var addBtn  = root.querySelector('.p1-add');
    var meter   = root.querySelector('.p1-meter');
    var mtxt    = root.querySelector('.p1-mtxt');
    var fill    = root.querySelector('.p1-fill');
    var moreBtn = root.querySelector('.p1-more');

    /* ---------- the following bar ---------- */
    var bar = root.querySelector('.p1-bar');
    bar.innerHTML =
      '<img src="' + esc(GH.img(shots[0].src, 200)) + '" alt="" loading="lazy" decoding="async">' +
      '<span class="p1-barwho"><span class="p1-barname">' + esc(P.title) + '</span>' +
      '<span class="p1-barsub"></span></span>' +
      '<button type="button" class="p1-barbtn">Add</button>';
    var barSub = bar.querySelector('.p1-barsub');
    var barBtn = bar.querySelector('.p1-barbtn');

    function currentPlan() {
      if (!sub) return null;
      return plans.filter(function (p) { return String(p.id) === String(sub); })[0] || null;
    }

    function sync() {
      var v = GH.variantFor(P, chosen);
      syncers.forEach(function (fn) { try { fn(v); } catch (e) {} });
      var live = !!(v && v.available);
      var pl = currentPlan();
      var unit = v ? (pl ? GH.subPrice(v.price, pl.off) : v.price) : 0;
      var label = GH.chosenLabel(P, chosen);

      priceEl.textContent = v ? money(unit * qty) : '–';
      perEl.textContent = (qty > 1 ? qty + ' × ' : '') + label +
        (pl ? (label ? ' · ' : '') + pl.off + '% off' : '');
      numEl.textContent = String(qty);
      addBtn.disabled = !live;
      addBtn.textContent = !live ? 'Sold out'
        : (pl ? 'Subscribe' : (qty > 1 ? 'Add ' + qty + ' to cart' : 'Add to cart'));
      barBtn.disabled = !live;
      barBtn.textContent = !live ? 'Sold out' : (pl ? 'Subscribe' : 'Add');
      barSub.textContent = live
        ? money(unit * qty) + (label ? ' · ' + (qty > 1 ? qty + ' × ' : '') + label : '')
        : 'Sold out';

      root.querySelectorAll('.p1-step').forEach(function (b) {
        b.disabled = b.dataset.step === '-1' ? qty <= 1 : qty >= 10;
      });
      /* a value that has gone out of stock for everything else already picked reads as
         unavailable rather than accepting the tap and handing back a dead button */
      root.querySelectorAll('.p1-opt').forEach(function (b) {
        var n = b.dataset.opt, val = b.dataset.val;
        /* Pop whatever just became selected — including a button the customer did not
           touch, because picking a size can move the grind to keep the pair buyable and
           that is the moment they need to notice it moved. */
        var was = b.getAttribute('aria-pressed') === 'true';
        var now = chosen[n] === val;
        b.setAttribute('aria-pressed', String(now));
        if (now && !was && popsOn) pop(b);
        b.disabled = !GH.liveWith(P, n, val, chosen) &&
                     !(P.variants || []).some(function (x) {
                       return x.available && x.opts[n] === val; });
      });

      /* the two purchase cards, and each frequency's own price */
      if (plans.length && v) {
        root.querySelector('.p1-oncecost').textContent = money(v.price);
        var best = plans.reduce(function (a, b) { return b.off > a.off ? b : a; });
        root.querySelector('.p1-subcost').innerHTML =
          money(GH.subPrice(v.price, best.off)) + '<s>' + money(v.price) + '</s>';
        plans.forEach(function (p) {
          var el = root.querySelector('[data-planprice="' + p.id + '"]');
          if (el) el.textContent = money(GH.subPrice(v.price, p.off));
        });
        root.querySelectorAll('.p1-plan').forEach(function (c) {
          c.classList.toggle('is-on', (c.dataset.kind === 'sub') === !!sub);
        });
        root.querySelectorAll('.p1-freq').forEach(function (b) {
          var was = b.getAttribute('aria-pressed') === 'true';
          var now = !!(sub && String(b.dataset.plan) === String(sub));
          b.setAttribute('aria-pressed', String(now));
          if (now && !was && popsOn) pop(b);
        });
      }

      /* ---------- the free-shipping meter ----------
         Deliberately computed HERE and not in the shared library. The library ships in
         the data block, the design ships in its own block, and they get pasted at
         different times — a design calling a library function that a older paste does
         not have is how "Make undefined and ship free" reached the live site. Anything
         this design needs, this design owns.

         It counts the cart PLUS what is currently selected, so the bar actually moves as
         someone changes size, grind, quantity or subscription — which is the entire
         reason for putting it on a product page. It is worded as *this order*, never as
         a claim about what is already in the basket, so it cannot contradict the cart
         bar at the top of the page. */
      var freeAt = (GH.shared && GH.shared.freeShippingAt) || 35;
      /* Once the line has actually been added, it is IN inCart — counting the selection
         on top of that counted it twice and turned $19 into "$38, ships free" on an
         order the cart would still charge shipping for. justAdded is cleared the moment
         anything is changed again, so the bar goes back to previewing the selection. */
      var order  = inCart + (justAdded ? 0 : unit * qty);
      var shortBy = Math.round((freeAt - order) * 100) / 100;
      var isFree = shortBy <= 0;
      var cartNote = (inCart > 0 && !justAdded)
        ? ' Including the ' + money(inCart) + ' already in your cart.' : '';

      meter.classList.toggle('is-free', isFree);
      fill.style.width = Math.max(0, Math.min(100, order / freeAt * 100)) + '%';
      mtxt.innerHTML = isFree
        ? '<b>This order ships free.</b>' + cartNote
        : '<b>' + money(shortBy) + ' from free shipping.</b>' +
          ' This order is ' + money(order) + '.' + cartNote;

      /* how many of what they are looking at would actually clear the line */
      var need = unit > 0 ? Math.ceil((freeAt - inCart) / unit) : 0;
      if (!isFree && need > qty && need <= 10) {
        moreBtn.style.display = '';
        moreBtn.textContent = need === 2 ? 'Make it 2 and ship free'
                                         : 'Make it ' + need + ' and ship free';
      } else {
        moreBtn.style.display = 'none';
      }
    }

    /* Ripple on press rather than on click, so it starts the instant the finger lands
       instead of when it lifts. Nearest match wins, so a tap on a frequency chip ripples
       the chip and not the card it sits in. */
    root.querySelector('.p1-buy').addEventListener('pointerdown', function (e) {
      var host = e.target.closest
        ? e.target.closest('.p1-opt,.p1-freq,.p1-add,.p1-plan') : null;
      if (host && !host.disabled) ripple(host, e);
    });

    root.querySelector('.p1-buy').addEventListener('click', function (e) {
      var t = e.target;
      /* any change to size, grind, quantity or plan means the meter is previewing a
         selection again rather than reporting what was just added */
      if (!(t.closest && t.closest('.p1-add'))) justAdded = false;
      var o = t.closest ? t.closest('.p1-opt') : null;
      if (o) {
        chosen[o.dataset.opt] = o.dataset.val;
        /* if that leaves an impossible combination, move the other options to something
           this value actually comes in */
        if (!GH.variantFor(P, chosen)) {
          var fits = (P.variants || []).filter(function (x) {
            return x.opts[o.dataset.opt] === o.dataset.val && x.available; })[0];
          if (fits) chosen = JSON.parse(JSON.stringify(fits.opts));
        }
        sync(); return;
      }
      var fq = t.closest ? t.closest('.p1-freq') : null;
      if (fq) { sub = fq.dataset.plan; sync(); return; }
      var card = t.closest ? t.closest('.p1-planhead') : null;
      if (card) {
        var kind = card.parentNode.dataset.kind;
        sub = kind === 'sub' ? (sub || String(plans[0].id)) : null;
        sync(); return;
      }
      var st = t.closest ? t.closest('.p1-step') : null;
      if (st) { qty = Math.max(1, Math.min(10, qty + Number(st.dataset.step))); sync(); return; }
      if (t.closest && t.closest('.p1-more')) {
        /* jump straight to the quantity that clears the line, worked out here rather
           than read off the button's label */
        var pl2 = currentPlan();
        var v2  = GH.variantFor(P, chosen);
        var u2  = v2 ? (pl2 ? GH.subPrice(v2.price, pl2.off) : v2.price) : 0;
        var at2 = (GH.shared && GH.shared.freeShippingAt) || 35;
        var n2  = u2 > 0 ? Math.ceil((at2 - inCart) / u2) : qty + 1;
        qty = Math.min(10, Math.max(qty + 1, n2));
        sync(); return;
      }
      if (t.closest && t.closest('.p1-add')) { add(addBtn); }
    });


    /* the counter, and the note itself */
    var reqBox   = root.querySelector('.p1-reqbox');
    var reqCount = root.querySelector('.p1-reqcount span');
    if (reqBox) {
      reqBox.addEventListener('input', function () {
        var max = (S.specialRequests && S.specialRequests.max) || 150;
        reqCount.textContent = String(reqBox.value.length);
        reqCount.parentNode.classList.toggle('is-full', reqBox.value.length >= max);
      });
    }

    function add(btn) {
      var v = GH.variantFor(P, chosen);
      if (!v || !v.available) return;
      var target = btn || addBtn;
      var line = { id: v.id, quantity: qty, sellingPlan: sub };
      /* only attach the property when something was actually written, so every other
         order does not carry an empty "Special Requests" line */
      var note = reqBox ? reqBox.value.trim() : '';
      if (note) {
        line.properties = {};
        line.properties[(S.specialRequests && S.specialRequests.label) || 'Special Requests'] = note;
      }
      var was = target.textContent;
      target.disabled = true; target.textContent = 'Adding…';
      GH.addToCart(line)
        .then(function () {
          target.textContent = 'Added ✓';
          return GH.cartTotal();
        })
        .then(function (t) {
          /* null means the cart could not be read, not that it is empty. Believing the
             zero here is how the meter came to announce "This order is $0" one second
             after a successful add. Keep the last known total instead. */
          if (t != null) inCart = t;
          justAdded = true;
          setTimeout(function () { target.disabled = false; sync(); }, 1600);
        })
        /* never leave them with a dead button — fall back to a real form post. If the
           post is blocked, or the browser will not leave the page, put the button back
           rather than stranding it disabled on "Adding…". */
        .catch(function () {
          try { GH.postFallback(line); } catch (e) {}
          setTimeout(function () {
            if (target.disabled) { target.disabled = false; target.textContent = was; }
          }, 2500);
        });
    }
    barBtn.addEventListener('click', function () { add(barBtn); });

    /* The bar shows once the real button has scrolled off the top, and goes away again
       past the end of the section.

       Deliberately not IntersectionObserver: that only reports when the intersecting
       state CHANGES, and a fast flick — or a browser restoring a scroll position — can
       take the button from below the viewport to above it in one sample. Both ends are
       "not intersecting", so no callback ever fires and the bar never appears. Reading
       the geometry each frame cannot miss it. */
    var queued = false;
    function checkBar() {
      queued = false;
      var b = addBtn.getBoundingClientRect(), s = root.getBoundingClientRect();
      var on = b.bottom < 0 && s.bottom > 80;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }
    function onScroll() {
      if (queued) return;
      queued = true;
      (window.requestAnimationFrame || function (fn) { setTimeout(fn, 16); })(checkBar);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    sync();
    popsOn = true;
    checkBar();
    /* same rule as after an add: an unreadable cart is not an empty one */
    GH.cartTotal().then(function (t) { if (t != null) { inCart = t; sync(); } });

    /* ---------- what people say ----------
       Three cases, in order:

       A product with its OWN reviews shows those and says so — the chocolates have two
       real ones in Loox, and they are about the chocolates, so it would be daft to show
       shop-wide coffee praise instead.

       A coffee with none of its own still shows the shop's, because which coffee a review
       got filed under in Shopify is an artefact of the import rather than a judgement
       about that coffee, and every one of them is a real customer on real coffee.

       Everything else — the granola, the mug, the tumbler, the t-shirt — shows NOTHING.
       They have no reviews, and borrowing coffee reviews to sell a mug would be putting
       words in customers' mouths. The section is absent, not empty. */
    var own = P.reviews && P.reviews.length ? P.reviews : null;
    var rv = S.reviews;
    var items = own || (P.kind === 'coffee' && rv && rv.items && rv.items.length
                        ? rv.items : null);
    if (items) {
      root.querySelector('.p1-social').innerHTML =
        '<div class="p1-sochead">' +
          '<span class="p1-socstars" aria-hidden="true">★★★★★</span>' +
          '<h2 class="p1-soch">' +
            esc(own ? 'What people say about these' : (rv && rv.title) || 'What people say') +
          '</h2>' +
          /* Where the reviews are the shop's rather than this coffee's, say so. The line
             was already written and already had a style rule; it simply was never
             printed, which left Colombia reading "5.0 from 1 review" above six reviews
             that are not about Colombia. The style rule .p1-socnote has existed since
             the first build for exactly this. */
          (!own && rv && rv.note
            ? '<p class="p1-socnote">' + esc(rv.note) + '</p>'
            : '') +
        '</div>' +
        '<ul class="p1-revs">' + items.map(function (r) {
          return '<li class="p1-rev"><span class="p1-revt">&ldquo;' + esc(r.t) +
                 '&rdquo;</span><span class="p1-revn">' + esc(r.n) + '</span></li>';
        }).join('') + '</ul>';
    } else {
      root.querySelector('.p1-social').style.display = 'none';
    }

    /* ---------- learn about this roast ----------
       All six panels, in the live order. The two that are a figure rather than an essay
       get a lighter treatment, but nothing is dropped. A mug has none of this, so the
       whole section stays out rather than sitting there empty. */
    var panels = GH.roastPanels(P);
    if (!panels.length) root.querySelector('.p1-read').style.display = 'none';
    var SHORT = { 'Elevation': 1, 'Harvest Season': 1 };
    var longs  = panels.filter(function (r) { return !SHORT[r[0]]; });
    var shorts = panels.filter(function (r) { return SHORT[r[0]]; });

    function block(r) {
      return '<div class="p1-sec"><h3 class="p1-h3">' + esc(r[0]) + '</h3>' +
             (SHORT[r[0]]
               ? '<p class="p1-short">' + GH.lines(r[1]).map(esc).join('<br>') + '</p>'
               : GH.paras(r[1], 'p1-p')) +
             '</div>';
    }

    /* The film goes under the paragraph it actually illustrates: the sourcing films
       under Origin Story, the drying film under Processing Method. Shopify's own words
       decide which — see add_videos.py. If that panel is missing for some product the
       film simply falls to the end of the column rather than vanishing. */
    var V = P.video;
    function vidHTML(where) {
      if (!V) return '';
      var src = ((window.GH_DATA && GH_DATA.vcdn) || 'https://cdn.shopify.com/videos/c/vp/') +
                V.id + '/' + V.id + '.' + V.r + '.mp4';
      return '<figure class="p1-vid p1-vid--' + where + '">' +
        '<button type="button" class="p1-play" data-src="' + esc(src) + '" ' +
          'aria-label="Play video: ' + esc(V.alt) + '">' +
          '<img src="' + esc(GH.img(V.poster, 900)) + '" alt="" loading="lazy">' +
          '<span class="p1-pbadge"><i></i></span>' +
          '<span class="p1-pcap">' + esc(V.cap) + '</span>' +
        '</button></figure>';
    }

    var leftHTML = longs.map(function (r) {
      return block(r) + (V && V.under === r[0] ? vidHTML('flow') : '');
    }).join('');
    /* it never matched a panel, so it still has to appear somewhere */
    if (V && longs.every(function (r) { return r[0] !== V.under; })) leftHTML += vidHTML('flow');

    root.querySelector('.p1-read').innerHTML =
      '<div class="p1-readhead"><h2 class="p1-h2">' + esc(S.roastTitle) + '</h2></div>' +
      '<div class="p1-left">'  + leftHTML + '</div>' +
      '<div class="p1-right">' + shorts.map(block).join('') + vidHTML('side') + '</div>';

    /* built on click, not on load — see the note by .p1-vid */
    root.querySelector('.p1-read').addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.p1-play') : null;
      if (!b) return;
      /* The film exists twice — one copy for the phone layout, one for the desktop
         column — and crossing 750px hides whichever was playing WITHOUT stopping it.
         Turning a handset sideways was enough: the audio kept going from a display:none
         element, the stream kept downloading, and the poster for the other copy came
         back so a second player could be started on top. Only ever one player. */
      root.querySelectorAll('.p1-vid video').forEach(function (old) {
        try { old.pause(); old.removeAttribute('src'); old.load(); } catch (err) {}
        var fig = old.parentNode;
        if (fig) {
          var back = document.createElement('div');
          back.innerHTML = vidHTML(fig.className.indexOf('--side') > -1 ? 'side' : 'flow');
          var fresh = back.firstChild;
          if (fresh) fig.parentNode.replaceChild(fresh, fig);
        }
      });
      var v = document.createElement('video');
      v.src = b.dataset.src;
      v.controls = true; v.autoplay = true; v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('preload', 'auto');
      b.parentNode.replaceChild(v, b);
      v.focus();
    });

    /* ---------- how it's made ---------- */
    var M = P.made;
    var madeEl = root.querySelector('.p1-made');
    if (!M) { madeEl.style.display = 'none'; }
    else {
      madeEl.innerHTML =
        '<span class="p1-madek">' + esc(M.kicker) + '</span>' +
        '<h2 class="p1-madet">' + esc(M.title) + '</h2>' +
        '<p class="p1-madeb">' + esc(M.blurb) + '</p>' +
        (M.stat && M.stat.length
          ? '<div class="p1-stats">' + M.stat.map(function (s) {
              return '<div class="p1-stat"><span class="p1-statk">' + esc(s[0]) +
                     '</span><span class="p1-statv">' + esc(s[1]) + '</span></div>';
            }).join('') + '</div>'
          : '') +
        (M.items && M.items.length
          ? '<div class="p1-ing"><span class="p1-ingl">' + esc(M.itemsLabel) + '</span>' +
            '<div class="p1-ings">' + M.items.map(function (x) {
              return '<span class="p1-ingi">' + esc(x) + '</span>';
            }).join('') + '</div></div>'
          : '') +
        /* a second headed passage, for the part of the story that needs more than a
           stat — the granola's oats. Optional; the chocolates do not use it. */
        (M.story
          ? '<div class="p1-story"><h3 class="p1-h3">' + esc(M.story.title) + '</h3>' +
            GH.paras(M.story.body, 'p1-p') + '</div>'
          : '') +
        (M.warn ? '<span class="p1-warn">' + esc(M.warn) + '</span>' : '') +
        (M.link
          ? '<a class="p1-madelink" href="/products/' + esc(M.link.handle) + '">' +
            esc(M.link.label) + '</a>'
          : '');
    }

    /* ---------- the Trio's three coffees, each in its own colour ---------- */
    var TM = mem;
    var triEl = root.querySelector('.p1-tri');
    if (!TM || !TM.length) { triEl.style.display = 'none'; }
    else {
      /* The arithmetic is the strongest thing on a bundle page and it was not being
         shown. Both numbers are real and both are computed here rather than typed:
         the sum of what these three bags cost individually, against what this one
         actually charges. If any price changes in Shopify, this follows it. */
      var solo = TM.reduce(function (t, m) { return t + (m.solo || 0); }, 0);
      /* the selected variant only exists inside sync(); out here, ask for it directly.
         Both Trio grinds are the same price, so either answers the question. */
      var tv = GH.variantFor(P, chosen) || (P.variants || [])[0];
      var here = (tv && tv.price) || 0;
      var save = solo - here;
      var freeAt = (S && S.freeShippingAt) || 35;

      triEl.innerHTML =
        (solo && here && save > 0
          ? '<div class="p1-save">' +
              '<div class="p1-savei"><span class="p1-savek">Bought separately</span>' +
                '<span class="p1-savev p1-savewas">' + money(solo) + '</span></div>' +
              '<div class="p1-savei"><span class="p1-savek">In the box</span>' +
                '<span class="p1-savev">' + money(here) + '</span></div>' +
              '<div class="p1-savei p1-saveg"><span class="p1-savek">You keep</span>' +
                '<span class="p1-savev">' + money(save) + '</span></div>' +
            '</div>' +
            (here >= freeAt
              ? '<p class="p1-saveship">Over ' + money(freeAt) +
                ', so it ships free on its own.</p>' : '')
          : '') +
        '<h2 class="p1-trih">Three coffees, three different cups</h2>' +
        '<p class="p1-tris">One box, one grind choice, and these three bags inside it.</p>' +
        '<div class="p1-trim">' + TM.map(function (m) {
          /* the cap takes that coffee's colour, and its type takes whichever of ink or
             white actually reads on it — the same rule the buttons follow */
          var t = tone(m.color);
          return '<a class="p1-trib" href="/products/' + esc(m.handle) + '">' +
            '<span class="p1-tricap" style="background:' + t.bg + '">' +
              '<span class="p1-trishot"><img src="' + esc(GH.img(m.img, 200)) +
                '" alt="" loading="lazy"></span>' +
              '<span><span class="p1-trin" style="color:' + t.tx + '">' + esc(m.title) +
                '</span>' +
              (m.roast ? '<span class="p1-trir" style="color:' + t.tx + '">' +
                esc(m.roast) + ' roast</span>' : '') + '</span>' +
            '</span>' +
            /* Not the flavour notes — those are already printed at the top of this page,
               so repeating them here said nothing new. These are the three things that
               actually differ between the three coffees, in the same order on each card
               so they can be read across rather than down. */
            '<span class="p1-trifacts">' + (m.facts || []).map(function (f) {
              return '<span class="p1-trifact"><span class="p1-trifk">' + esc(f.k) +
                     '</span><span class="p1-trifv">' + esc(f.v) + '</span></span>';
            }).join('') + '</span></a>';
        }).join('') + '</div>' +
        /* Someone who reads all three cards has just been sold, and until now the page
           gave them nothing to press — the next thing down was other products. This adds
           the same line the button at the top adds, using whichever grind is selected up
           there, so nobody has to scroll back to buy. */
        '<div class="p1-triend">' +
          '<button type="button" class="p1-add p1-triadd"></button>' +
          '<p class="p1-triendn"></p>' +
        '</div>';
    }

    /* the second Add, at the foot of the three coffees. It shares add() with the button
       in the buy box, so the grind, the quantity and the subscription choice made up
       there are exactly what this adds — two buttons, one decision. */
    var triAdd = root.querySelector('.p1-triadd');
    if (triAdd) {
      triAdd.addEventListener('click', function () { add(triAdd); });
      /* keep its label in step with the choice above it */
      syncers.push(function (variant) {
        var g = chosen && chosen.Grind ? chosen.Grind : '';
        /* add() posts `qty`, so this label has to price `qty` too — it read $45 while
           adding $135 at quantity three */
        triAdd.textContent = !variant ? 'Add the Trio'
          : !variant.available ? 'Sold out'
          : (qty > 1 ? 'Add ' + qty + ' Trios' : 'Add the Trio') +
            (g ? ' · ' + g : '') + ' · ' + money(variant.price * qty);
        triAdd.disabled = !variant || !variant.available;
        var note = root.querySelector('.p1-triendn');
        if (note) note.textContent = variant && variant.available
          ? 'Three 12oz bags, one box.' : 'Currently unavailable.';
      });
    }
    sync();

    /* ---------- where to go next ----------
       Three real pages and three real products. Every URL was checked against the live
       site; the quiz is the same Netlify link the FAQ page already points at. */
    var N = S.next || {};
    function head(l, extraCls) {
      return '<a class="p1-link ' + extraCls + '" href="' + esc(l.href) + '"' +
        (l.external ? ' target="_blank" rel="noopener"' : '') + '><span class="p1-pad">' +
        '<span class="p1-linkk">' + esc(l.kicker) + '</span>' +
        '<span class="p1-linkt">' + esc(l.title) + '</span>';
    }

    /* the brew sheet, with the ratios that are actually on the Coffee Lab page */
    function labCard(l) {
      return head(l, 'p1-lab') +
        '<span class="p1-linkb">' + esc(l.blurb) + '</span>' +
        '<span class="p1-labrows">' + (l.rows || []).map(function (r) {
          return '<span class="p1-labrow"><span class="p1-labn">' + esc(r[0]) +
                 '</span><span class="p1-labv">' + esc(r[1]) + '</span></span>';
        }).join('') + '</span>' +
        '<span class="p1-linkc">' + esc(l.cta) + ' &rsaquo;</span></span></a>';
    }
    /* the quiz's real first question, so the card is the thing it opens */
    function quizCard(l) {
      return head(l, 'p1-quiz') +
        '<span class="p1-qstep">' + esc(l.step) + '</span>' +
        '<span class="p1-q">' + esc(l.q) + '</span>' +
        '<span class="p1-qopts">' + (l.options || []).map(function (o) {
          return '<span class="p1-qopt"><span class="p1-qe" aria-hidden="true">' + esc(o.e) +
            '</span><span><span class="p1-qt">' + esc(o.t) + '</span>' +
            '<span class="p1-qd">' + esc(o.d) + '</span></span></span>';
        }).join('') + '</span>' +
        '<span class="p1-linkc">' + esc(l.cta) + ' &rsaquo;</span></span></a>';
    }
    /* the cabinet */
    function arcadeCard(l) {
      return head(l, 'p1-arcade') +
        '<span class="p1-linkb">' + esc(l.blurb) + '</span>' +
        '<span class="p1-games">' + (l.games || []).map(function (g) {
          return '<span class="p1-game"><span class="p1-gamen">' + esc(g[0]) +
                 '</span><span class="p1-gamed">' + esc(g[1]) + '</span></span>';
        }).join('') + '</span>' +
        '<span class="p1-start">' + esc(l.cta) + '</span></span></a>';
    }

    /* ---------- the Trio upgrade ----------
       Honduras, Ethiopia and the Espresso Blend ARE the Trio, so on those three pages
       offering it sideways in "goes well with this" undersells it. It gets its own band
       above instead, and the row below swaps it for a coffee that is not one of the
       three — a different one on each, so the three pages do not read the same. */
    var T = S.trio || {};
    var inTrio = (T.members || []).indexOf(P.handle) !== -1;

    if (inTrio) {
      var bags = (T.members || []).map(function (h) {
        return (window.GH_COFFEE || []).filter(function (x) { return x.handle === h; })[0];
      }).filter(Boolean);
      var save = (T.separate || 0) - (T.price || 0);
      root.querySelector('.p1-trio').innerHTML =
        '<a class="p1-up" href="/products/' + esc(T.handle) + '"><span class="p1-upin">' +
          '<span class="p1-upk">' + esc(T.kicker) + '</span>' +
          '<span class="p1-upt">' + esc(T.title) + '</span>' +
          '<span class="p1-upbags">' + bags.map(function (b) {
            var here = b.handle === P.handle;
            return '<span class="p1-upbag' + (here ? ' is-this' : '') + '">' +
              '<span class="p1-upshot"><img src="' + esc(GH.img(b.images[0].src, 300)) +
                '" alt="' + esc(b.title) + '" loading="lazy" decoding="async"></span>' +
              '<span class="p1-upname">' + esc(b.title) + '</span>' +
              (here ? '<span class="p1-upthis">You&rsquo;re here</span>' : '') +
              '</span>';
          }).join('') + '</span>' +
          '<span class="p1-upline">' + esc(T.line) + '</span>' +
          (T.note ? '<span class="p1-upnote">' + esc(T.note) + '</span>' : '') +
          '<span class="p1-upmoney"><span class="p1-upnow">' + money(T.price) + '</span>' +
            '<span class="p1-upwas">' + money(T.separate) + '</span>' +
            (save > 0 ? '<span class="p1-upsave">Save ' + money(save) + '</span>' : '') +
          '</span>' +
          '<span class="p1-upcta">' + esc(T.cta) + '</span>' +
        '</span></a>';
    }

    /* the recommendation row: on a Trio page, the Trio comes out and a coffee goes in */
    var also = (S.alsoLike || []).filter(function (a) { return a.handle !== P.handle; });
    if (inTrio) {
      var swapTo = (S.altRec || {})[P.handle];
      var c = (window.GH_COFFEE || []).filter(function (x) { return x.handle === swapTo; })[0];
      also = also.filter(function (a) { return a.handle !== T.handle; });
      if (c) {
        var live = (c.variants || []).filter(function (v) { return v.available; });
        also.unshift({
          handle: c.handle, title: c.title,
          /* its own three flavour notes — no claim about why it is being shown */
          blurb: (c.notes || []).join(' · '),
          from: live.length ? Math.min.apply(null, live.map(function (v) { return v.price; })) : null,
          img: c.images[0].src
        });
      }
    }

    root.querySelector('.p1-next').innerHTML =
      (also.length
        ? '<h2 class="p1-nexth">' + esc(S.alsoTitle) + '</h2>' +
          '<div class="p1-also">' + also.map(function (a) {
            return '<a class="p1-alsoitem" href="/products/' + esc(a.handle) + '">' +
              '<span class="p1-alsoshot"><img src="' + esc(GH.img(a.img, 400)) +
                '" alt="' + esc(a.title) + '" loading="lazy" decoding="async"></span>' +
              '<span class="p1-alsobody"><span class="p1-alsot">' + esc(a.title) + '</span>' +
                '<span class="p1-alsob">' + esc(a.blurb) + '</span>' +
                '<span class="p1-alsop">From ' + money(a.from) + '</span></span></a>';
          }).join('') + '</div>'
        : '') +
      (N.lab || N.quiz || N.arcade
        ? '<div class="p1-extra">' +
            '<span class="p1-extrak">' + esc(S.moreKicker) + '</span>' +
            '<h2 class="p1-extrah">' + esc(S.linksTitle) + '</h2>' +
            '<p class="p1-extras">' + esc(S.moreSub) + '</p>' +
            '<div class="p1-links">' +
              (N.lab    ? labCard(N.lab)       : '') +
              (N.quiz   ? quizCard(N.quiz)     : '') +
              (N.arcade ? arcadeCard(N.arcade) : '') +
            '</div>' +
          '</div>'
        : '');
  }
});
